/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectGsvPerMonthPerFamilyResponse
 */
export interface ProjectGsvPerMonthPerFamilyResponse {
    /**
     * 
     * @type {string}
     * @memberof ProjectGsvPerMonthPerFamilyResponse
     */
    monthAndYear: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectGsvPerMonthPerFamilyResponse
     */
    freelancerFamily: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectGsvPerMonthPerFamilyResponse
     */
    gsv: number;
}

/**
 * Check if a given object implements the ProjectGsvPerMonthPerFamilyResponse interface.
 */
export function instanceOfProjectGsvPerMonthPerFamilyResponse(value: object): value is ProjectGsvPerMonthPerFamilyResponse {
    if (!('monthAndYear' in value) || value['monthAndYear'] === undefined) return false;
    if (!('freelancerFamily' in value) || value['freelancerFamily'] === undefined) return false;
    if (!('gsv' in value) || value['gsv'] === undefined) return false;
    return true;
}

export function ProjectGsvPerMonthPerFamilyResponseFromJSON(json: any): ProjectGsvPerMonthPerFamilyResponse {
    return ProjectGsvPerMonthPerFamilyResponseFromJSONTyped(json, false);
}

export function ProjectGsvPerMonthPerFamilyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectGsvPerMonthPerFamilyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'monthAndYear': json['monthAndYear'],
        'freelancerFamily': json['freelancerFamily'],
        'gsv': json['gsv'],
    };
}

export function ProjectGsvPerMonthPerFamilyResponseToJSON(value?: ProjectGsvPerMonthPerFamilyResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'monthAndYear': value['monthAndYear'],
        'freelancerFamily': value['freelancerFamily'],
        'gsv': value['gsv'],
    };
}

